import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(private readonly msalService: MsalService, private readonly router: Router) { }
    canActivate(): boolean | UrlTree {
        const urlView = window.location.href.split('/');
    
        // Checa se a URL contém "view" e, caso positivo, permite acesso sem autenticação
        if (urlView.includes('view')) {
            console.log('Página view, acesso permitido sem autenticação');
            return true;
        }
    
        // Se não for página "view", verifica se o usuário está autenticado
        if (this.msalService.instance.getAllAccounts().length === 0) {
            console.log('Usuário não autenticado, redirecionando...');
            return this.router.createUrlTree(['/login']); // Redireciona para login ou outra página
        }
    
        return true;  // Permite acesso à página
    }
    
}
